// Supports exhaustive checks in switch statements
export function assertUnmatched(x: never): never {
  throw new Error(`argument out of range: ${x}`)
}

// Supports creating a type with only the keys of T that match Predicate
export type ExtractKeysWhere<T, Predicate> = {
  [K in keyof T]: T[K] extends Predicate ? K : never
}[keyof T]
